import { render, staticRenderFns } from "./sme-buy-policy.vue?vue&type=template&id=7c87a2da&scoped=true&"
import script from "./sme-buy-policy.vue?vue&type=script&lang=js&"
export * from "./sme-buy-policy.vue?vue&type=script&lang=js&"
import style0 from "./sme-buy-policy.vue?vue&type=style&index=0&id=7c87a2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87a2da",
  null
  
)

export default component.exports